import { render, staticRenderFns } from "./AdvertisingCard.vue?vue&type=template&id=6bc74764&scoped=true&"
import script from "./AdvertisingCard.vue?vue&type=script&lang=js&"
export * from "./AdvertisingCard.vue?vue&type=script&lang=js&"
import style0 from "./AdvertisingCard.vue?vue&type=style&index=0&id=6bc74764&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc74764",
  null
  
)

export default component.exports